import { useSelector } from 'react-redux';
import { getIsDarkModeEnabled } from '../../store/selectors';
import { DarkTheme, LightTheme } from '../RollioTheme';

export const useSelectedTheme = () => {
  const darkModeSetting = useSelector(getIsDarkModeEnabled);

  return darkModeSetting ? DarkTheme : LightTheme;
};
